var app = angular.module('app')
    .filter('currencyFormat', formatPrice);

function formatPrice () {
    return function (price, currency, digits = 2){
        price = parseFloat(price);
        price = price.toFixed(digits);        

        switch (currency) {
            case 'USD':        
                price = price.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1');                                    
                return 'USD $ ' + price;
                break;

            case 'GBP':   
                price = price.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1,');                     
                return '£ ' + price + ' GBP';
                break;

            case 'CAD':  
                price = price.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1');                      
                return 'CAD $ ' + price;
                break;

            case 'EUR':
                price = price.toString().replace(".", ",").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
                //.replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
                return 'EUR € ' + price;
                break;

            case 'BRL':
                price = price.toString().replace(".", ",").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
                return 'R$ ' + price;
                break;

            case 'AED':
                price = price.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1');  
                return price + ' د.إ';
                break;

            default:
                return price;
                break;
        }                
    }
}